import { createSelector } from 'reselect';
import { PAGE_INDICES } from '../../actions/doctorsPi/types';
import { getDoctorsPiState } from './index';

const getRouting = createSelector(getDoctorsPiState, (state) => state.routing);

export const getActivePageIndex = createSelector(
    getRouting,
    routing => routing.activePageIndex,
);
export const getDoDoctorsPiNavigation = createSelector(
    getRouting,
    routing => routing.doNavigation,
);
export const getDoExitDoctorsPiNavigation = createSelector(
    getRouting,
    routing => routing.doExitNavigation,
);

export const getLandingPage = createSelector(
    getRouting,
    routing => routing.landingPage,
);


const makeGetIsPage = pageIndex =>
    createSelector(
        getRouting,
        routing => routing.activePageIndex === pageIndex,
    );
export const getIsQuotePage = makeGetIsPage(PAGE_INDICES.QOUTE);
export const getIsPersonalDetailsPage = makeGetIsPage(PAGE_INDICES.PERSONAL_DETAILS);
export const getIsDocumentsPage = makeGetIsPage(
    PAGE_INDICES.UPLOAD_DOCUMENTS,
);
export const getIsPaymentPage = makeGetIsPage(PAGE_INDICES.PAYMENT);

export const getProgressBarIndex = createSelector(
	getIsQuotePage,
	getIsPersonalDetailsPage,
	getIsDocumentsPage,
	getIsPaymentPage,
	(isQuotePage, isPersonalDetailsPage, isDocumentsPage, isPaymentPage) => {
		if (isQuotePage) return 0;
		if (isPersonalDetailsPage) return 1;
		if (isDocumentsPage) return 2;
		if (isPaymentPage) return 3;
	}
);
